import { StaticImage } from "gatsby-plugin-image"
import React, { useEffect, useState } from "react"
import HeadingCover from "../../../components/text/heading-cover/heading-cover"
import CardsCarousel from "../../../components/cards-carousel/cards-carousel"
import Button from "../../../components/button/button"
import JobTransformationCard from "../../../components/JobTransformationCard/JobTransformationCard"
import { FaStar } from "react-icons/fa"
import BodyText from "../../../components/text/body-text/body-text"
import { RiDoubleQuotesL } from "react-icons/ri"
import * as styles from "./index.module.css"
import Dialog from "../../../components/dialog/dialog"
import VideoPlayer from '../../../components/video-player/video-player'
import RegistrationForm from "../../../components/CustomDialogs/RegistrationForm"
// main
const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const HomePotentialProfessional = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [videoUrl, setVideoUrl] = useState(undefined);
  const [isRegistrationFormOpen, setIsRegistrationFormOpen] = useState(false);
  useEffect(()=>{
    if(!showDialog){
      setVideoUrl(undefined);
    }
  },[showDialog])

  const ProfessionalsData = [
    {
      key: "1",
      imageSrc: (
          <StaticImage
            className={styles.userImage}
            src="../../../images/potential/monika.png"
            alt="Profile picture of Monika, GST Assistant at Natukashii Creations PVT.LTD, who transitioned from being an unemployed M.Com graduate to a successful entrepreneur."
          />
      ),
      name: "Monika",
      company: "Natukashii Creations PVT.LTD",
      jobTitle: "GST Assistant",
      before: "M.com & Unemployed ",
      after: "Successful Entrepreneur",
    },
    {
      key: "2",
      imageSrc: (
          <StaticImage
            className={styles.userImage}
            src="../../../images/potential/Renu Singh.png"
            alt="Profile picture of Renu Singh, General Duty Assistant at JINPU-KAI, who transitioned from a beauty advisor in a mall to a caregiver in Japan."
          />
      ),
      name: "Renu Singh",
      company: "JINPU-KAI ",
      jobTitle: "General Duty Assistant ",
      before: "Beauty Advisor in a mall ",
      after: "Care Giver in Japan ",
    },

    {
      key: "3",
      imageSrc: (
          <StaticImage
            className={styles.userImage}
            src="../../../images/potential/SALIM RAI.png"
            alt="Profile picture of Salim Rai, Assistant Electrician at Saipatri, who went from being a struggling electrician to a successful entrepreneur."
            
          />
      ),
      name: "Salim Rai",
      company: "Saipatri",
      jobTitle: "Assistant Electrician",
      before: "Struggling Electrician",
      after: "Successful Entrepreneur",
    },
    {
      key: "4",
      imageSrc: (
          <StaticImage
            className={styles.userImage}
            src="../../../images/potential/Dyaneshwar.JPG"
            alt="Profile picture of Dyaneshwar Shivaji, CNC Operator at Horizon Engineering, who moved from being an unemployed diploma holder to a Supervisor in the CNC Department."
          />
      ),
      name: "Dyaneshwar Shivaji",
      company: "Horizon Engineering ",
      jobTitle: "CNC Operator ",
      before: "Diploma & Unemployed ",
      after: "Supervisor CNC Department ",
    },
  ]
  const testimonialData = [
    {
      title: "Global Mobility Programme",
      role: "Work in Japan",
      description:
        "Our talented alumni achieved their dreams of working in Japan through the Global Mobility Programme ",
      image: (
        <StaticImage
          key="1"
          src="../../../images/potential/Image101.png"
          alt="Portrait of a woman who achieved her dream of working in Japan through the Global Mobility Programme"
          className="h-full"
          {...commonImageProps}
        />
      ),
      videoUrl: 'https://storage.googleapis.com/learnet-content/assets/videos/SANJANA%201.40.mp4'
    },
    {
      title: "Castrol Sarathi Mitra",
      role: "",
      description:
        "Up-skilling truck drivers with road safety, financial literacy, & well-being for a safer, brighter future.",
      image: (
        <StaticImage
          key="2"
          src="../../../images/potential/Castrol.jpg"
          alt="Portrait of a man participating in the Castrol Sarathi Mitra program for truck driver upskilling"
          className="h-full"
          {...commonImageProps}
        />
      ),
      videoUrl: 'https://storage.googleapis.com/learnet-content/assets/videos/Castrol%20Saarthi%20Mitra.mp4'
    },
    {
      title: "Global Mobility Programme",
      role: "",
      description:
        "From farming to a thriving career in Germany—watch Manjit's inspiring journey to success. ",
      image: (
        <StaticImage
          key="1"
          src="../../../images/potential/ManjitTamang.jpeg"
          alt="Portrait of Manjit Tamang, who transitioned from farming to a successful career in Germany through the Global Mobility Programme"
          className="h-full"
          {...commonImageProps}
        />
      ),
      videoUrl: 'https://storage.googleapis.com/learnet-content/assets/videos/Manjit%20Tamang-%20LIS%20Kalimpong%20alumni%20(Learnet)%20(Cut-06).mp4'
    },
  ]
  return (
    <>
      <HeadingCover className="px-4 text-center mb-8 mx-auto">
        <span>From</span> Potential <span>To </span>Professional
      </HeadingCover>

      <div className="bg-[linear-gradient(white_25%,_#e0f1ff_25%,_#e0f1ff_100%)]  py-6">
        <div className="container mx-auto items-center flex flex-col md:flex-row">
          <div className="w-full md:w-1/2">
            <CardsCarousel
              carouselSettingsOverride={{
                slidesToScroll: 1,
                slidesToShow: 2,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: ProfessionalsData.length > 2,
                dots: ProfessionalsData.length > 2,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      dots: ProfessionalsData.length > 2,
                      infinite: ProfessionalsData.length > 2,
                    },
                  },
                  {
                    breakpoint: 800,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      dots: ProfessionalsData.length > 2,
                      //infinite: ProfessionalsData.length > 2,
                    },
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: ProfessionalsData.length > 2,
                      //infinite: ProfessionalsData.length > 2,
                    },
                  },
                ],
              }}
            >
              {ProfessionalsData.map(card => (
                <div key={card.key} className="flex px-4 gap-6 h-full">
                  <JobTransformationCard
                    imageSrc={card.imageSrc}
                    name={card.name}
                    company={card.company}
                    jobTitle={card.jobTitle}
                    before={card.before}
                    after={card.after}
                  />
                </div>
              ))}
            </CardsCarousel>
          </div>
          <div className="w-full md:w-1/2 px-4">
            <CardsCarousel
              carouselSettingsOverride={{
                slidesToScroll: 1,
                slidesToShow: 1,
                autoplay: true,

                autoplaySpeed: 5000,
                infinite: true,
                dots: true,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: true,
                      infinite: true,
                    },
                  },
                  {
                    breakpoint: 800,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: testimonialData.length > 1,
                    },
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: testimonialData.length > 1,
                    },
                  },
                ],
              }}
            >
              {testimonialData.map(item => (
                <div key={item} className="h-full" onClick={()=>{
                  setVideoUrl(item.videoUrl);
                  setShowDialog(true);
                }}>
                  <div className="flex bg-[#4559ED] h-full ">
                    <div className="w-3/5 relative flex flex-col justify-around items-start p-4">
                      <div className="flex justify-between items-center w-[90%]">
                        <BodyText variant="bodyText5" className="text-white font-bold">
                          {item.title}
                        </BodyText>
                        {/* <RiDoubleQuotesL color="#FFFFFF" fontSize="56px" opacity="0.5" /> */}
                      </div>
                      <BodyText variant="bodyText6" className="text-white w-[90%]">
                        {item.description}
                      </BodyText>
                      <BodyText
                        variant="bodyText7 "
                        className="text-white font-bold w-[90%]"
                      >
                        {item.role ? "-" : ""}
                        {item.role}
                      </BodyText>
                      <StaticImage
                        src="../../../images/potential/Group 79036.svg"
                        alt="play button"
                        className={styles.playButton}
                      />
                    </div>

                    <div className="w-2/5 md:max-h-[17vw]">{item.image}</div>
                  </div>
                </div>
              ))}
            </CardsCarousel>
          </div>
        </div>
      </div>
      <Dialog
        onClose={() => setShowDialog(false)}
        isOpen={showDialog}
        setIsDialogOpen={setShowDialog}
      >
        {videoUrl && (
          <VideoPlayer
            videoUrl={videoUrl}
            options={{
              aspectRatio: "16:9",
              // poster: "https://storage.googleapis.com/schoolnet-content/videos/about/about.jpg",
            }}
          />
        )}
      </Dialog>
      <div className="text-center mt-8 mx-auto">
        <Button className="mb-0" onClick={()=>setIsRegistrationFormOpen(true)}>Register Now</Button>
      </div>
      <RegistrationForm isOpen={isRegistrationFormOpen} setIsOpen={setIsRegistrationFormOpen} clickedFrom={"Home-Potential Professional"}/>
    </>
  )
}
